import { Box, Paper, Skeleton } from '@mui/material';
import React from 'react';

const QuoteCardSkeleton = () => {
  return (
    <Paper
      sx={{
        padding: 2,
        borderRadius: 1.25,
        backgroundColor: '#ffffff',
        border: '1px solid #EBEBEB',
        height: '100%',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box
        display="flex"
        alignItems="flex-start"
        justifyContent="space-between"
        style={{ gap: 12 }}
      >
        <Skeleton
          variant="text"
          width="70%"
          height={32}
          style={{ marginBottom: 6 }}
        />
        <Box
          display="flex"
          gap={0.5}
          alignItems="center"
        >
          <Skeleton
            variant="circular"
            width={32}
            height={32}
          />
          <Skeleton
            variant="circular"
            width={32}
            height={32}
          />
        </Box>
      </Box>
      <Skeleton
        variant="text"
        width="50%"
        height={20}
        style={{ marginBottom: 24, opacity: 0.85 }}
      />
      <Box
        display="flex"
        flexDirection="column"
        gap={0.5}
        style={{ marginTop: 'auto' }}
      >
        <Box
          display="flex"
          gap={1}
          alignItems="center"
        >
          {[1, 2, 3, 4, 5].map((index) => (
            <Skeleton
              key={index}
              variant="circular"
              width={32}
              height={32}
            />
          ))}
        </Box>
        <Skeleton
          variant="text"
          width="60%"
          height={14}
        />
      </Box>
    </Paper>
  );
};

export default QuoteCardSkeleton;
